import { forwardRef } from 'react';
import { TextFieldProps } from '@mui/material';

import { StyledTextField } from './MplTextArea.styled';

export interface IMplTextAreaProps
	extends Omit<TextFieldProps, 'multiline' | 'variant'> {
	minRows?: number;
	maxRows?: number;
}

export const MplTextArea = forwardRef<HTMLDivElement, IMplTextAreaProps>(
	({ minRows = 3, maxRows = 6, ...props }, ref) => {
		return (
			<StyledTextField
				ref={ref}
				multiline
				minRows={minRows}
				maxRows={maxRows}
				variant="outlined"
				fullWidth
				{...props}
			/>
		);
	}
);

MplTextArea.displayName = 'MplTextArea';
